module.exports = __webpack_public_path__ + "media/images/help/submission-management-page-806eabc5449f7dca6e66d832cb1dc9e4.png";